import issuedLoan from './issued-loan';
import issuedLoanCollateral from './issued-loan-collateral';
import issuedLoanPayment from './issued-loan-payment';
import receivedLoan from './received-loan';
import receivedLoanPayment from './received-loan-payment';

let messages = Object.assign({}, issuedLoan, issuedLoanCollateral, issuedLoanPayment, receivedLoan, receivedLoanPayment);

export default messages;
